export default [
    // French
    'fr/home/welcome',
    'fr/user/user',
    'fr/user/products/requests',
    'fr/template/menu',

    // English
    'en/home/welcome',
    'en/user/user',
    'en/user/products/requests',
    'en/template/menu',
]



// WEBPACK FOOTER //
// ./src/companies/casino/lang/conf.js